import React, { Component } from 'react';
import { Field, reduxForm, change, formValueSelector, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import withStyles from 'isomorphic-style-loader/withStyles';


import Loader from '../../Common/Loader/Loader';
import CommonImageDisplay from '../CommonImageDisplay/CommonImageDisplay';
import Link from '../../Link/Link';
import ImageUploadComponent from '../../Common/ImageUploadComponent/ImageUploadComponent.js';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent.js';
import SelectFieldComponent from '../../Common/SelectFieldComponent/SelectFieldComponent.js';

import submit from './submit';
import messages from '../../../locale/messages';
import validate from './validate';
import { siteUrl, homePageCategoryBannerUploadDir, homePageCategoryLogoUploadDir } from '../../../config';
import { formatLocale } from '../../../helpers/formatLocale';
import { demoRestriction } from '../../../actions/demoRestriction';

//images
import { AddContentPlusIcon, DeleteContentPlusIcon } from '../../Common/Assets/SVGIcon/CommonSvgRemainingIcon.js';

import bt from '../../../components/commonStyle.css';
import s from './CategoryForm.css';


export class CategoryForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedLanguages: []
		}
	}

	static defaultProps = { loading: false };

	UNSAFE_componentWillReceiveProps(nextProps) {
		const { dynamicTopFeatureTitle } = nextProps;
		let filteredLanguages = dynamicTopFeatureTitle?.map((item) => { return item?.language })
		this.setState({ selectedLanguages: filteredLanguages });
	}

	loaderStart = async (index) => {
		const { change } = this.props;
		await change(`categoryList.loading`, true);
	}

	loaderEnd = async (index) => {
		const { change } = this.props;
		await change(`categoryList.loading`, false);
	}


	renderFieldArray = ({ fields, meta: { touched, error }, label }) => {
		const { languageList } = this.props;
		const { formatMessage } = this.props.intl;
		const { selectedLanguages } = this.state;

		!fields.length && fields.push({})
		return (
			<div className={bt.languageBox}>
				{fields.map((item, index) => {
					let fieldLength = fields.length - 1;
					const currentLanguage = fields?.get(index)?.language;
					const availableLanguages = languageList.filter(locale => !selectedLanguages?.includes(locale) || locale === currentLanguage);
					const languagesOption = [{ value: '', label: formatMessage(messages.chooseLanguageLabel) }];
					const languageOptionsFormatted = availableLanguages.map((locale) => {
						return {
							value: locale,
							label: formatLocale(locale)
						};
					});
					languagesOption.push(...languageOptionsFormatted);

					return (
						<div key={`${index}`}>
							<div className='twoColumnGrid'>
								<div className='oneColumnGrid'>
									<Field
										name={`${item}.language`}
										component={SelectFieldComponent}
										label={formatMessage(messages.language)}
										options={languagesOption}
										inputClass={bt.formControlSelect}
									/>
									<Field
										name={`${item}.title`}
										type="text"
										component={InputFieldComponent}
										label={label}
										placeholder={label}
										inputClass={bt.formControlInput} />
								</div>
								<Field
									name={`${item}.description`}
									type="text"
									component={InputFieldComponent}
									componentClass="textarea"
									label={formatMessage(messages.featureDesc1)}
									placeholder={formatMessage(messages.featureDesc1)}
									inputClass={cx(bt.formTextArea, bt.descTextArea)} />
							</div>

							<div className={cx(bt.languageBtnContainer, 'svgImg', { [bt.languageBtnContainerOne]: (fieldLength > 0) })} >
								{(fields.length <= languageList?.length - 1) && fieldLength == index &&
									<Button onClick={() => fields.length <= languageList?.length - 1 && fields.push({})} className={cx(bt.languageBtn)}>
										<AddContentPlusIcon />
										<span>	{formatMessage(messages.addLanguage)}</span>
									</Button>
								}
								{fieldLength > 0 && <div>
									<Button className={cx(bt.languageBtn, bt.languageDeleteBtn)} onClick={() => fields.remove(index)}>
										<DeleteContentPlusIcon />
										<span>{formatMessage(messages.deleteLanguage)}</span>
									</Button>
								</div>}
							</div>
						</div>
					)
				})}
			</div >
		)
	}

	successlogo = async (file, fromServer) => {
		const { change, demoRestriction } = this.props;
		let fileName = fromServer.fileName;
		const isRestrict = await demoRestriction({});
		if (isRestrict) return;
		await change('logo', fileName);
	}

	successBanner = async (file, fromServer) => {
		const { change, demoRestriction } = this.props;
		let fileName = fromServer.fileName;
		const isRestrict = await demoRestriction({});
		if (isRestrict) return;
		await change('banner', fileName);
	}

	render() {
		const { handleSubmit, loading, submitting, logo, banner, id, bannerImageLoader, logoImageLoader } = this.props;
		const { formatMessage } = this.props.intl;

		return (
			<Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
				<h1 className='siteAdminPrimaryHeading'>{!id ? formatMessage(messages.addFeature) : formatMessage(messages.editFeature)}</h1>
				<Row>
					<Col lg={6} md={6} sm={12} xs={12} className={bt.space4}>
						<div className={cx(s.profileImgSection, s.profileImgWidth)}>
							<label className={bt.commonLabelText} >{formatMessage(messages.aboutImage1)}</label>
							<CommonImageDisplay imageSrc={logo ? siteUrl + homePageCategoryLogoUploadDir + 'medium_' + logo : null} loader={logoImageLoader} />
							<ImageUploadComponent
								className='commonSiteAdminDropzoneSpace'
								subText={formatMessage(messages.maximumUploadSizeLabel)}
								defaultMessage={formatMessage(messages.chooseFile)}
								componentConfig={{
									iconFiletypes: ['.jpg', '.png', '.svg'],
									multiple: false,
									showFiletypeIcon: false,
									postUrl: siteUrl + '/uploadHomePageCategoryLogo'
								}}
								success={this.successlogo}
								loaderName={'logoImageLoader'}
							/>
						</div>
					</Col>
					<Col lg={6} md={6} sm={12} xs={12} className={bt.space4}>
						<div className={cx(s.profileImgSection, s.profileImgWidth)}>
							<label className={bt.commonLabelText} >{formatMessage(messages.aboutImage2)}</label>
							<CommonImageDisplay imageSrc={banner ? siteUrl + homePageCategoryBannerUploadDir + 'medium_' + banner : null} loader={bannerImageLoader} />
							<ImageUploadComponent
								className='commonSiteAdminDropzoneSpace'
								subTextClass={cx(s.subText)}
								subText={formatMessage(messages.maximumUploadSizeLabel)}
								defaultMessage={formatMessage(messages.chooseFile)}
								componentConfig={{
									iconFiletypes: ['.jpg', '.png', '.svg'],
									multiple: false,
									showFiletypeIcon: false,
									postUrl: siteUrl + '/uploadHomePageCategoryBanner'
								}}
								success={this.successBanner}
								loaderName={'bannerImageLoader'}
							/>
						</div>
					</Col>
				</Row>

				<FieldArray
					name='title'
					rerenderOnEveryChange={true}
					component={this.renderFieldArray}
					label={formatMessage(messages.featureTitle1)} />

				<div className={cx(bt.spaceTop5, bt.paddingTop5, bt.languageBtnDivider, 'doubleBtnFlexEnd')}>
					<Link className={cx(bt.btnSecondary)}
						to={'/siteadmin/homepage/top-feature'}>
						{formatMessage(messages.goBack)}

					</Link>
					<Loader
						type={"button"}
						label={formatMessage(messages.submitButton)}
						show={loading}
						buttonType={'submit'}
						className={cx(bt.btnPrimary, 'loaderButtonFlex')}
						disabled={submitting || loading}
					/>
				</div>
			</Form>
		)
	}
}

CategoryForm = reduxForm({
	form: 'CategoryForm',
	onSubmit: submit,
	validate
})(CategoryForm);

const selector = formValueSelector('CategoryForm');
const mapState = (state) => ({
	logo: selector(state, 'logo'),
	banner: selector(state, 'banner'),
	categoryList: selector(state, 'categoryList'),
	loading: state.loader.CategoryForm,
	dynamicTopFeatureTitle: selector(state, 'title'),
	languageList: state?.runtime?.availableLocales,
	id: selector(state, 'id'),
	bannerImageLoader: state?.loader?.bannerImageLoader,
	logoImageLoader: state?.loader?.logoImageLoader,
});
const mapDispatch = {
	change,
	demoRestriction
};

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(CategoryForm)));